import MainGoal from "../../components/Forms/MainGoal";
import BasicCard from "../BasicCard";
import MainLayout from "../MainLayout";
import Dummylayout from "../Dummylayout";

function GoalsForm() {
    return (
        <>
        {/* <MainLayout/> */}
           <div> <Dummylayout/></div>
    
<div className="mx-5 pl-5">
            <BasicCard>
                <MainGoal />
               
            </BasicCard>
            </div>
        </>
    )
}
export default GoalsForm;